import {BaseAppPrefs} from "../shared/BaseAppPrefs";
import {Codabot} from "./types";

export class AppPrefs extends BaseAppPrefs {

  static readonly PREF_CODABOT = "codabot";
  static readonly PREF_SPEED = "speed";
  static readonly PREF_TUTORIAL = "tutorial";

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  getCodabot(): Codabot {
    return this.prefs.getString(AppPrefs.PREF_CODABOT) as Codabot || Codabot.RED;
  }

  setCodabot(codabot: Codabot): void {
    this.prefs.setString(AppPrefs.PREF_CODABOT, codabot);
    this.notify(AppPrefs.PREF_CODABOT);
  }

  getSpeed(): number {
    return this.prefs.getNumber(AppPrefs.PREF_SPEED) || 1;
  }

  setSpeed(speed: number): void {
    this.prefs.setNumber(AppPrefs.PREF_SPEED, speed);
    this.notify(AppPrefs.PREF_SPEED);
  }

  getTutorial(): boolean {
    return this.prefs.getBoolean(AppPrefs.PREF_TUTORIAL) || false;
  }

  setTutorial(tutorial: boolean): void {
    this.prefs.setBoolean(AppPrefs.PREF_TUTORIAL, tutorial);
  }
}
